export default "__VITE_ASSET___PShZMo0__"